import React from 'react';
import { useField } from 'react-final-form';

import { SIZE } from '@motorway/mw-highway-code/enums';
import { InputVRM } from '@motorway/mw-highway-code/pre-alpha';
import { Intent } from '@motorway/mw-highway-code/src/types';

import { FeedbackTooltip } from 'Storybook/components/local/FeedbackTooltip/FeedbackTooltip';

import {
  coerceVRM, composeValidators, getFieldState,
  isValidVRM, requiredValidator, VRMValidator,
} from '../../../../checkerPages/Pages/CheckerRouter.utils';

import styles from './CarCheckerVRMField.scss';

const FIELD_NAME = 'carCheckVrm';

type CarCheckVrmFieldProps = {
  texts: {
    errorMessage: string;
    label: string;
  };
};

export const CarCheckerVRMField = ({ texts }: CarCheckVrmFieldProps) => {
  const { errorMessage } = texts;

  const { input, meta } = useField<string>(FIELD_NAME, {
    format: (value) => (isValidVRM(value) ? coerceVRM(value) : value),
    formatOnBlur: true,
    initialValue: '',
    parse: (value: string) => value.toLocaleUpperCase(),
    validate: composeValidators(
      requiredValidator(errorMessage),
      VRMValidator(errorMessage),
    ),
  });

  const intent = getFieldState(meta, false) as Intent;
  const inputAriaLabels = {
    'aria-errormessage': 'errorTooltip',
    'aria-invalid': intent === 'error',
    'aria-required': 'true',
  };
  const tooltipContent = <span id='errorTooltip'>{meta.error}</span>;

  return (
    <fieldset className={ styles.vrmCheckFieldset }>
      <FeedbackTooltip
        appendTo='parent'
        className={styles.tooltip}
        content={tooltipContent}
        intent={intent}
        interactive={false}
        placement='top'
      >
        <section className={styles.inputWrapper}>
          <InputVRM
            data-thc-vrm-input
            fullWidth
            formProps={{
              input: {
                ...input,
                ...inputAriaLabels,
                autoCapitalize: 'characters',
                maxLength: 10,
              },
            }}
            id={`${FIELD_NAME}-id`}
            intent={intent ?? undefined}
            label={''}
            size={SIZE.LARGE}
          />
        </section>
      </FeedbackTooltip>
    </fieldset>
  );
};
